<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]">
    <div class="w-100">
      <l-map ref="memMap" style="width: 100vw; height: 92.5vh;" :center="center" :zoom="zoom" @dblclick="dbClick">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <l-marker :lat-lng="marker" v-for="marker in markers" :key="marker.lat + marker.lng"> </l-marker>
        <v-geosearch :options="geosearchOptions"></v-geosearch>
      </l-map>
    </div>
    <div class="info">
      <div class="bulle">
        <div class="cadre">
          <p>
            Pour commencer, choisis un lieu dans lequel tu as un souvenir de camp ou d’un moment de nature qui t’as
            marqué. <br />
            Double-clique ensuite sur le lieu que tu as choisis et parle nous de ton souvenir ! Tu pourras ensuite te
            promener parmis les souvenirs des explorêveur·êuses.
          </p>
        </div>
      </div>
      <img src="https://cdn.exploreve.fr/content/personnages/leon.svg" alt />
    </div>
    <b-modal ref="addMemoryModal" hide-footer>
      <template v-slot:modal-title> Créer mon souvenir </template>
      <div class="d-block text-center">
        <b-form-group label="Ton prénom / surnom, ne mets pas de nom de famille ! (*)">
          <b-form-input
            v-model="user_name"
            type="text"
            required
            placeholder="Ton nom"
            :state="user_name_invalid"
          ></b-form-input>
          <b-form-invalid-feedback v-if="user_name_empty">
            Il faut mettre ton nom
          </b-form-invalid-feedback>
          <b-form-invalid-feedback v-if="user_name_already_taken">
            Ce nom d'utilisateur est déjà utilisé
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Ton age (*)">
          <b-form-input
            v-model="user_age"
            type="number"
            required
            placeholder="Ton age"
            :state="user_age_invalid"
          ></b-form-input>
          <b-form-invalid-feedback :state="user_age_invalid">
            Il faut mettre ton age
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Ton mouvement scout (*)">
          <b-form-select
            v-model="user_mvt"
            :options="scouts_mvts"
            required
            value="EEDF"
            :state="user_mvt_invalid"
          ></b-form-select>
          <b-form-invalid-feedback :state="user_mvt_invalid">
            A quel mouvement appartient plus ?
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Résume ton souvenir en 3 mots (*)">
          <b-form-input
            v-model="user_words"
            type="text"
            required
            placeholder="Mes 3 mots"
            :state="user_words_invalid"
          ></b-form-input>
          <b-form-invalid-feedback :state="user_words_invalid">
            Nous avons besoin de 3 mots pour décrire ton souvenir !
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label="Ton souvenir" description="Raconte nous ton souvenir avec des mots ou une adresse URL">
          <b-form-textarea
            v-model="user_message"
            type="text"
            required
            placeholder="écris ton souvenir, ou laisse nous un lien vers une chanson qui te le rappelles www.youtube.fr"
            :state="user_message_invalid"
          ></b-form-textarea>
          <b-form-invalid-feedback :state="user_message_invalid">
            Ton message doit faire moins de 400 charactères !
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <span class="small-text text-muted">Les champs de fomulaires avec un (*) sont obligatoires</span>
      <b-button class="mt-3" block @click="presend">Créer ce souvenir</b-button>
    </b-modal>
    <scarf ref="scarf_modal" @scarf="presend"></scarf>
  </div>
</template>

<script>
// @ is an alias to /src
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import Service from "@/services/memoryMap";
import ProgressTracker from "@/services/ProgressTracker";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import ScarfModal from "../scarf_modal";
import API from "@/services/ApiService";

export default {
  name: "IM_2_3",
  data: function () {
    return {
      id: 4,
      url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",
      attribution: `Fond de carte : &copy; <a href="https://www.thunderforest.com/">Thunderforest</a>, Données : &copy; les contributeurs d'<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>`,
      zoom: 8,
      center: [47.41322, -1.219482],
      bounds: null,
      icon: {},
      markers: [],
      user_name: "",
      user_mvt: "",
      user_age: 0,
      user_words: "",
      user_message: "",
      leaved_word_list: false,
      scouts_mvts: ["SGDF", "EEDF", "EEUDF", "EEIF", "SMF", "EDLN", "AGSE", "SUF", "FEE", "Ecl Neutres", "autre"],
      geosearchOptions: {
        provider: new OpenStreetMapProvider()
      },
      errors: []
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    dbClick: function (event) {
      this.markers.unshift(event.latlng);
      this.$refs.addMemoryModal.show();
    },
    presend: async function () {
      return await this.send();
      // else return this.$refs.scarf_modal.openModal();
    },
    send: async function () {
      /*       if (!this.user_name_invalid || !this.user_age_invalid || !this.user_mvt_invalid || !this.user_words_invalid) {
        return this.$bvToast.toast("Tu as au moins 1 champ du formulaire invalide !", {
          title: "Oh non !",
          variant: "error"
        });
      } */
      let user = {
        lat: this.markers[0].lat,
        lng: this.markers[0].lng,
        scarf_id: localStorage.getItem("scarf_id") ? Number(localStorage.getItem("scarf_id")) : 217,
        display_name: this.user_name,
        age: Number(this.user_age),
        movement: this.user_mvt,
        souvenir_type:
          this.user_message.trim().length === 0 ? "none" : this.user_message.trim().startsWith("http") ? "url" : "text",
        souvenir_content: this.user_message.length > 0 ? this.user_message : "/",
        word_list: JSON.stringify({ words: this.user_words.trim().split(" ") })
      };

      API.post("/souvenirs", user)
        .then(() => {
          this.$refs.addMemoryModal.hide();
          return ProgressTracker.updateTracker();
        })
        .then(() => {
          this.$router.push("/immersion02/" + (this.id + 1));
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          /*         if (this.errors.findIndex((e) => e.field === "scarf_id") !== -1) {
          this.$bvToast.toast("Ton foulard à déjà été utilisé par quelqu'un d'autre. Il faut le refaire", {
            title: "Oh non !",
            variant: "error"
          });
          this.$refs.scarf_modal.openModal();
        } */
        });
    }
  },
  components: { LMap, LTileLayer, LMarker, VGeosearch, scarf: ScarfModal },
  mounted: function () {
    this.icon = Service.getIcon();
    this.emitMusic("play", "musicsouvenirs");
    this.$refs.memMap.mapObject.doubleClickZoom.disable();
  },
  computed: {
    user_name_invalid: function () {
      return !this.user_name_empty && !this.user_name_already_taken;
    },
    user_name_empty: function () {
      return this.user_name.trim().length === 0;
    },
    user_age_invalid: function () {
      return this.user_age > 0 && this.user_age < 120;
    },
    user_mvt_invalid: function () {
      return this.scouts_mvts.findIndex((e) => e === this.user_mvt) !== -1;
    },
    user_words_invalid: function () {
      return this.user_words.trim().split(" ").length === 3;
    },
    user_message_invalid: function () {
      return this.user_message.trim().length < 400;
    },
    user_name_already_taken: function () {
      const valid = this.errors.findIndex((e) => e.field === "display_name") !== -1;
      return valid;
    }
  }
};
</script>

<style scoped lang="scss">
.info {
  position: absolute;
  z-index: 1000;
  bottom: 3vh;
  left: 5vw;
  & img {
    height: 40vh;
  }
}
.bulle {
  position: absolute;
  bottom: 72vh;
  left: -4vw;
}
.cadre {
  position: absolute;
  background-color: white;
  width: 340px;
  border-radius: 20px;
  text-align: left;
  padding: 20px;
  z-index: 10;
}

.cadre::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 22%;
  width: 0;
  height: 0;
  transform: rotate(90deg);
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 60px solid white;
}
</style>
